import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import EpiContext from '@episerver/spa-core/Spa';
import {connect} from 'react-redux';
import {replacePlaceholders} from '../../../../utilities/StringHelpers/TitleHelpers';
import {buildUrlAndOpenSameWindow} from '../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../Config';
import {PersonalPricePlanStep} from '../constant';
import {setCurrentStep, setShowPopup, updatePricePlan} from '../personalPricePlanBlockSlice';
import {dwhReportBuilder} from '../reportDwh';
import { getSubscriberWithoutFamilyPlan , placeHolderFunctions} from '../constant';

const GeneralMessage = ({messageData, personalPricePlan, setCurrentStep, setShowPopup, updatePricePlan}) => {
  const {icon, title, secondTitle, subTitle, buttonList, isPopup, subTitleCondition, width = '440px'} = messageData;


  useEffect(() => {
    if(messageData.report){
      dwhReportBuilder(messageData.report);
    }
  }, []);
  const handleSubmit = (buttonAction, report) => {
    if(report){
      dwhReportBuilder(report);
    }
    switch (buttonAction) {
      case 'selectOtherPricePlan':
        setCurrentStep(PersonalPricePlanStep.SelectPackage);
        setShowPopup(false);
        break;
      case 'privateLobby':
        buildUrlAndOpenSameWindow(Config.lobbyUrl);
        break;
      case 'closePopup':
        setShowPopup(false);
        break;
      case 'updatePricePlan':
        updatePricePlan();
        break;
      case 'getNewCellularPlan':
        buildUrlAndOpenSameWindow(Config.joinCellularServiceLink);
        break;
    }
  };


  return (
    <>
      <div className='general-message-page' style={{width: width}}>
        <div className='general-message-page-content'>
          <Image src={icon} />
          <p className='title' dangerouslySetInnerHTML={{__html: replacePlaceholders(title, personalPricePlan, isMobile, placeHolderFunctions).replace(/\n/g, '<br />')}} />
          {secondTitle && (
            <p className='m-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(secondTitle, personalPricePlan, isMobile, placeHolderFunctions).replace(/\n/g, '<br />')}} />
          )}
          {subTitle && (!subTitleCondition  || subTitleCondition(personalPricePlan) )&& (
            <p className='m-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(subTitle, personalPricePlan, isMobile , placeHolderFunctions).replace(/\n/g, '<br />')}} />
          )}
        </div>
        <div className='buttons-wrapper'> 
          {buttonList.map((button, index) => (
            <div className='continue-button'>
                <BtnSubmit className={button.color} key={index} text={button.text} onclick={() => handleSubmit(button.click , button.report)} />
            </div>
          ))}
      </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  messageData: state.personalPricePlan.messageData,
  personalPricePlan: state.personalPricePlan,
});

const mapDispatchToProps = {setCurrentStep, setShowPopup, updatePricePlan};
export default connect(mapStateToProps, mapDispatchToProps)(GeneralMessage);
